/**
 * @generated SignedSource<<d3922b4eaefbb5d2e0c7029d70704fa1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateXeroOauthTokenSwapInput = {
  verifier?: string | null;
  tmpInvoiceId?: string | null;
  install?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createXeroOauthTokenKeySwapMutation$variables = {
  input: CreateXeroOauthTokenSwapInput;
};
export type createXeroOauthTokenKeySwapMutation$data = {
  readonly createXeroOauthTokenSwap: {
    readonly key: string | null;
  } | null;
};
export type createXeroOauthTokenKeySwapMutation = {
  variables: createXeroOauthTokenKeySwapMutation$variables;
  response: createXeroOauthTokenKeySwapMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateXeroOauthTokenSwapPayload",
    "kind": "LinkedField",
    "name": "createXeroOauthTokenSwap",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createXeroOauthTokenKeySwapMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createXeroOauthTokenKeySwapMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a6ba36eeecde95c4624653a6a455d7e0",
    "id": null,
    "metadata": {},
    "name": "createXeroOauthTokenKeySwapMutation",
    "operationKind": "mutation",
    "text": "mutation createXeroOauthTokenKeySwapMutation(\n  $input: CreateXeroOauthTokenSwapInput!\n) {\n  createXeroOauthTokenSwap(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "179761369ac4ec0a4bec36599608de78";

export default node;
